var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDarkRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 2.35889C4.88447 2.35889 2.35889 4.88447 2.35889 7.99992C2.35889 11.1154 4.88447 13.6409 7.99992 13.6409C11.1154 13.6409 13.6409 11.1154 13.6409 7.99992C13.6409 4.88447 11.1154 2.35889 7.99992 2.35889ZM1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992ZM7.4871 5.26488C7.4871 4.98165 7.7167 4.75206 7.99992 4.75206H8.00676C8.28998 4.75206 8.51958 4.98165 8.51958 5.26488C8.51958 5.5481 8.28998 5.7777 8.00676 5.7777H7.99992C7.7167 5.7777 7.4871 5.5481 7.4871 5.26488ZM6.80334 7.99992C6.80334 7.7167 7.03293 7.4871 7.31616 7.4871H7.99992C8.28314 7.4871 8.51274 7.7167 8.51274 7.99992V10.2221H8.68368C8.9669 10.2221 9.1965 10.4517 9.1965 10.735C9.1965 11.0182 8.9669 11.2478 8.68368 11.2478H7.99992C7.7167 11.2478 7.4871 11.0182 7.4871 10.735V8.51274H7.31616C7.03293 8.51274 6.80334 8.28314 6.80334 7.99992Z",
    fill: "#932A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDarkRed);
export default __webpack_public_path__ + "static/media/info-dark-red.267cb757fd92c9134fab08ed73b65c6f.svg";
export { ForwardRef as ReactComponent };